/**
 * axios封装
 */

import axios from 'axios'
import Vue from 'vue'
import qs from 'qs'
/**
 * axios请求拦截器
 * @param {object} config axios请求配置对象
 * @return {object} 请求成功或失败时返回的配置对象或者promise error对象
 **/
let loading;
let i = 0;
let configUrl = "https://hft02.evergrande.com/broker";
let configUrl1="https://hft02.evergrande.com"
axios.interceptors.request.use(config => {
	i++;
	loading = Vue.prototype.$loading({
		lock: true,
		text: '',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0,0)'
	});
	return config;
}, error => {
	return Promise.reject(error);
})

/**
 * axios 响应拦截器
 * @param {object} response 从服务端响应的数据对象或者error对象
 * @return {object} 响应成功或失败时返回的响应对象或者promise error对象
 **/
axios.interceptors.response.use(response => {
	i--
	if(i == 0) {
		loading.close();
	}

	if(response.data && typeof response.data == "object") {
		if(response.data.code == 4003) {
			errorMessaage("抱歉，您没有权限查看该页面。");
			return Promise.reject(response);
		} else if(response.data.code == -1001) {
			errorMessaage("TOKEN失效,请重新登录。");
			return Promise.reject(response);
		} else if(response.data.code == 4001) {
			errorMessaage("请求参数不正确。", true);
			return Promise.reject(response);
		} else if(response.data.code === 0) {
			errorMessaage(response.data.msg || response.data.message, true);
			return Promise.reject(response);
		}
	}
	return response.data;
}, error => { //响应错误处理
	if(error.response) {
		if(error.response.status === 504 || error.response.status === 404) {
			errorMessaage("请查看网络是否链接。");
		} else if(error.response.status === 403) {
			errorMessaage("抱歉，您没有权限查看该页面。");
		} else {
			errorMessaage("未知错误。");
		}
	}
	return Promise.reject(error);
})

export default {
	configUrl: configUrl,
	axiosPost(url, params) {
		//		 'Content-Type': 'application/x-www-form-urlencoded'
		return new Promise(function(resolve, reject) {
			axios({
				method: 'post',
				url: configUrl + url,

				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: qs.stringify(params),
			}).then((response) => {
				resolve(response);
			})

		})
	},
	axiosGet(url, params) {
		//		 'Content-Type': 'application/x-www-form-urlencoded'
		return new Promise(function(resolve, reject) {
			axios({
				method: 'get',
				url: configUrl1 + url,

				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}).then((response) => {
				resolve(response);
			})

		})
	},
}


// WEBPACK FOOTER //
// ./src/util/axios.js